import { useSearchParams } from 'react-router-dom';

export function ThankYouPage() {
  const [searchParams] = useSearchParams();
  const practice = searchParams.get('practice');

  const followUpText = practice
    ? `If you need to follow up, please contact ${decodeURIComponent(practice)} directly.`
    : 'If you need to follow up, please contact your provider\'s office directly.';

  return (
    <div className="container">
      <div className="card text-center" style={{ marginTop: '4rem' }}>
        <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>&#10003;</div>
        <h1 style={{ fontSize: '1.5rem', marginBottom: '0.5rem' }}>Visit Complete</h1>
        <p className="text-muted">Thank you for your telehealth visit. You may close this window.</p>
        <p className="text-muted text-sm mt-2">{followUpText}</p>
      </div>
    </div>
  );
}
